import axios from "axios";

export function SendNotificationFunction(data) {
  const token = localStorage.getItem("rfis");

  const jsonData = JSON.stringify(data);
  return axios.post(
    process.env.REACT_APP_BASE_URL + `api/v1/notification`,
    jsonData,
    {
      headers: {
        rf_token_header123_k: token,
        "Content-Type": "application/json",
      },
    }
  );
}

export function getNotification() {
  const bannerToken = localStorage.getItem("rfis");
  return axios.get(
    process.env.REACT_APP_BASE_URL + `api/v1/notification/all-notification`,
    {
      headers: {
        rf_token_header123_k: bannerToken,
        "Content-Type": "application/json",
      },
    }
  );
}

export function deleteNotification(id) {
  const token = localStorage.getItem("rfis");
  return axios.delete(
    process.env.REACT_APP_BASE_URL + `api/v1/notification/${id}`,
    {
      headers: {
        rf_token_header123_k: token,
        "Content-Type": "application/json",
      },
    }
  );
}

export function updateNotification(id, data) {
  const token = localStorage.getItem("rfis");
  return axios.put(
    process.env.REACT_APP_BASE_URL + `api/v1/notification/update/${id}`,
    data,
    {
      headers: {
        rf_token_header123_k: token,
        "Content-Type": "application/json",
      },
    }
  );
}
